import { BaseStatusDto } from './baseStatusDto';

export class GiftCardSalesChannelDto extends BaseStatusDto {}
